import logo from './logo.svg';
import './App.css';
import FullScreenCarousel from './container';

function App() {
  return (
   <FullScreenCarousel/>
  );
}

export default App;
